/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  ClickAwayListener, Paper, Typography, FormControl, Grid, Button,
} from '@material-ui/core';
import useStyles from './styles';

const Modal = ({
  title, ariaLabel, children, setState, onClose, onConfirm, confirmLabel, cancelLabel,
}) => {
  const classes = useStyles();

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
      return;
    }
    setState(false);
  }, [onClose, setState]);

  const handleConfirm = useCallback(() => {
    onConfirm();
  }, [onConfirm]);

  return (
    <div className={classes.container} aria-label={ariaLabel}>
      <ClickAwayListener onClickAway={handleClose}>
        <Paper classes={{ root: classes.panel }}>
          <FormControl component="fieldset" className={classes.formControl}>
            {title && <Typography className={classes.heading1}>{title}</Typography>}
            {children}
            <Grid container direction="row" justify="flex-end" alignItems="center">
              <Button onClick={handleClose}>{cancelLabel || 'CANCELAR'}</Button>
              <Button onClick={handleConfirm}>{confirmLabel || 'OK'}</Button>
            </Grid>
          </FormControl>
        </Paper>
      </ClickAwayListener>
    </div>
  );
};

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  setState: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
};

Modal.defaultProps = {
  setState: () => {},
  onClose: () => {},
};

export default Modal;
